import { PlaylistPage } from './../pages/playlist/playlist';
import { PlaylistsPage } from './../pages/playlists/playlists';
import { MenuPage } from './../pages/menu/menu';
import { BuyStep2Page } from './../pages/buy-step2/buy-step2';
import { BuyPage } from './../pages/buy/buy';
import { MediaService } from './../service/media.service';
import { AlbumPage } from './../pages/album/album';
import { AlbumService } from './../service/album.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { UserService } from '../service/user.service';
import { PlayerService } from '../service/player.service';
import { PlayerPage } from './../pages/player/player';
import { LoginPage } from './../pages/login/login';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { ProfilePage } from '../pages/profile/profile';
import { FindPage } from './../pages/find/find';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ExtendMenuProvider } from '../providers/extend-menu/extend-menu';

import { IonicStorageModule } from '@ionic/storage';
import { PlaylistNewPage } from '../pages/playlist-new/playlist-new';
import { CodePush } from '@ionic-native/code-push/ngx';
import { RegisterPage } from '../pages/register/register';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';

@NgModule({
  declarations: [
    MyApp,
    MenuPage,
    FindPage,
    ProfilePage,
    HomePage,
    TabsPage,
    LoginPage,
    PlayerPage,
    AlbumPage,
    BuyPage,
    BuyStep2Page,
    PlaylistsPage,
    PlaylistPage,
    PlaylistNewPage,
    RegisterPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp,{
      mode: 'md'
      }),
    HttpClientModule,
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    MenuPage,
    FindPage,
    ProfilePage,
    HomePage,
    TabsPage,
    LoginPage,
    PlayerPage,
    AlbumPage,
    BuyPage,
    BuyStep2Page,
    PlaylistsPage,
    PlaylistPage,
    PlaylistNewPage,
    RegisterPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    PlayerService,
    UserService,
    HttpClient,
    AlbumService,
    MediaService,
    CodePush,
    InAppPurchase2,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ExtendMenuProvider,
    CodePush
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts